import React from "react";
import { Alert, Badge } from "react-bootstrap";

export default function BonConsumHelp() {
  return (
    <div style={{ lineHeight: 1.55 }}>
      <p className="text-muted mb-3">
        Ajutor contextual pentru modulul <b>Bon Consum</b>. Deschizi manualul cu{" "}
        <Badge bg="secondary">F1</Badge> și îl închizi cu{" "}
        <Badge bg="secondary">Esc</Badge>.
      </p>

      <h5>1) Ce este Bonul de Consum</h5>
      <p>
        Bonul de consum este documentul prin care <b>scazi stoc</b> din gestiune
        pentru consum intern (materiale folosite, pierderi, uz, consum
        administrativ etc.). În mod normal:
      </p>
      <ul>
        <li>
          scăderea se face pe baza stocurilor existente (de regulă FIFO / pe
          loturi),
        </li>
        <li>
          sistemul generează mișcările de stoc (și eventual nota contabilă)
          conform configurării.
        </li>
      </ul>

      <Alert variant="info" className="py-2">
        <b>Recomandare:</b> Completează întâi antetul (dată, gestiune, tip bon),
        apoi adaugă liniile. Astfel eviți lipsa câmpurilor obligatorii la
        salvare.
      </Alert>

      <h5>2) Antet document (câmpuri importante)</h5>
      <ul>
        <li>
          <b>Număr document</b> – identificatorul bonului (poate fi manual sau
          generat).
        </li>
        <li>
          <b>Dată</b> – data documentului; FIFO / ordinea ieșirilor este de
          obicei legată de această dată.
        </li>
        <li>
          <b>Gestiune</b> – de unde se scade stocul (dacă la tine e la nivel de
          document).
        </li>
        <li>
          <b>Tip bon ieșire</b> – clasificare; poate influența conturile/nota
          (în funcție de cum ai configurat).
        </li>
        <li>
          <b>Observații</b> – motivul consumului, util pentru audit și căutare
          ulterioară.
        </li>
      </ul>

      <h5>3) Liniile documentului</h5>
      <p>
        O linie reprezintă un produs/serviciu scăzut din stoc. În mod uzual:
      </p>
      <ul>
        <li>
          <b>Produs</b> – articolul (bxpart) ales din listă.
        </li>
        <li>
          <b>Cantitate</b> – cantitatea de consumat.
        </li>
        <li>
          <b>Preț magazie</b> (dacă se afișează) – informativ sau folosit în
          calcul (depinde de implementare).
        </li>
      </ul>

      <Alert variant="warning" className="py-2">
        Dacă produsul are stoc pe mai multe intrări/loturi, sistemul poate
        genera <b>mai multe scăderi</b> în spate (FIFO), chiar dacă userul vede
        o singură linie.
      </Alert>

      <h5>4) Flux de lucru recomandat</h5>
      <ol>
        <li>
          Completează antetul: <b>dată</b>, <b>gestiune</b>, <b>tip bon</b>.
        </li>
        <li>
          Adaugă o linie și selectează <b>produsul</b>.
        </li>
        <li>
          Introdu <b>cantitatea</b>.
        </li>
        <li>Repetă pentru fiecare produs.</li>
        <li>
          Apasă <b>Salvează</b>.
        </li>
      </ol>

      <h5>5) Scurtături și butoane utile</h5>
      <ul>
        <li>
          <Badge bg="secondary">F1</Badge> – Deschide manualul (ajutor
          contextual).
        </li>
        <li>
          <Badge bg="secondary">Esc</Badge> – Închide manualul.
        </li>
        <li>
          <b>Salvează</b> – salvează documentul (în create + în edit).
        </li>
        <li>
          <b>Badge status “Modificat (nesalvat)”</b> – îți arată că există
          schimbări față de ultima salvare.
        </li>
      </ul>

      <h5>6) Validări și reguli (ce verifică sistemul de obicei)</h5>
      <ul>
        <li>
          <b>Câmpuri obligatorii</b> – lipsa lor duce la eroare 422 (ex: tip
          bon, gestiune, anumite câmpuri pe linii).
        </li>
        <li>
          <b>Cantitatea</b> trebuie să fie &gt; 0 (de regulă).
        </li>
        <li>
          <b>Stoc disponibil</b> – dacă nu există stoc suficient în gestiune,
          salvarea poate eșua sau scădea parțial (în funcție de regulile tale).
        </li>
        <li>
          <b>Conturi configurate</b> – dacă nota contabilă se generează automat,
          produsul / lotul trebuie să aibă conturi setate.
        </li>
      </ul>

      <h5>7) Erori frecvente și soluții</h5>

      <h6 className="mt-3">Eroare 422 – Field required</h6>
      <ul>
        <li>
          <b>Ce înseamnă:</b> payload-ul trimis la backend nu conține un câmp
          obligatoriu.
        </li>
        <li>
          <b>Ce faci:</b> verifică în formular că sunt completate câmpurile
          cerute (ex: tip bon/gestiune) și că liniile au toate câmpurile
          necesare.
        </li>
        <li>
          <b>Tipic la edit:</b> dacă deschizi un bon vechi și resalvezi, unele
          câmpuri pe linii pot lipsi (ex: alocări/loturi). În cazul ăsta trebuie
          fie mapare corectă la load, fie completare automată înainte de PUT.
        </li>
      </ul>

      <h6 className="mt-3">Stoc insuficient / Alloc invalid</h6>
      <ul>
        <li>
          <b>Ce înseamnă:</b> cantitatea cerută nu poate fi acoperită din
          stocurile disponibile.
        </li>
        <li>
          <b>Ce faci:</b> scade cantitatea, schimbă gestiunea (dacă e cazul),
          sau verifică dacă există intrări suficiente pentru produs.
        </li>
      </ul>

      <h6 className="mt-3">Cont lipsă / configurare contabilă incompletă</h6>
      <ul>
        <li>
          <b>Ce înseamnă:</b> sistemul încearcă să genereze o notă contabilă,
          dar produsul/lotul sau tipul bonului nu are conturile asociate.
        </li>
        <li>
          <b>Ce faci:</b> verifică setările de conturi pe produs / gestiune /
          tip bon.
        </li>
      </ul>

      <h5>8) Sfaturi practice</h5>
      <ul>
        <li>
          Pune în <b>Observații</b> motivul consumului (ex: “consum șantier X”,
          “pierderi”, “materiale mentenanță”).
        </li>
        <li>
          Dacă lucrezi pe aceeași gestiune des, setarea implicită reduce
          erorile.
        </li>
        <li>
          Dacă ai dubii la preț/scădere, verifică mișcările generate (stocout /
          notă) după salvare.
        </li>
      </ul>

      <h5>9) Întrebări rapide (FAQ)</h5>
      <ul>
        <li>
          <b>De ce nu văd toate scăderile pe loturi?</b> Pentru că UI arată
          linia “logică”, iar alocările pe lot (FIFO) sunt generate intern.
        </li>
        <li>
          <b>Pot edita un bon deja salvat?</b> Da, dar dacă au fost generate
          mișcări de stoc, editarea poate necesita refacerea alocărilor (depinde
          de reguli).
        </li>
      </ul>
    </div>
  );
}
